/*
 * @Author: meixianming
 * @Date: 2023-10-25 10:35:09
 * @LastEditors: WeijianXu weijian.xu@unidt.com
 * @LastEditTime: 2024-05-08 11:14:04
 * @Description: file content
 * @FilePath: /manage_property/src/core/request.js
 */
import axios from 'axios';
import { baseUrl, isFake, request, responseSuccess, responseError } from '@/config/request.js';
import virtualData from '@/data/virtualData.js';

//接口封装
const API = (options) => {
  // options.url = baseUrl + options.url
  //创建自定义请求实例
  const instance = axios.create({
    baseURL: options.baseUrl || baseUrl,
  });

  //请求拦截器
  instance.interceptors.request.use(request);

  // 响应拦截器
  instance.interceptors.response.use(responseSuccess, responseError);

  return instance(options);
};

//虚拟接口封装
const VirtualAPI = (option) =>
  new Promise((resolve) => {
    setTimeout(() => {
      resolve(virtualData[option.url]);
    }, 500);
  });

let exportAPI = isFake ? VirtualAPI : API;
export default exportAPI;
